import { render } from "./CampaignsBulkBaseSelector.vue?vue&type=template&id=c1cc9162&scoped=true"
import script from "./CampaignsBulkBaseSelector.vue?vue&type=script&lang=ts"
export * from "./CampaignsBulkBaseSelector.vue?vue&type=script&lang=ts"

import "./CampaignsBulkBaseSelector.vue?vue&type=style&index=0&id=c1cc9162&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c1cc9162"

export default script